export function getDefectPhotoUrl(defect, index) {
    if (defect.submission_id) {
        return `/api/media/defect-photo/${defect.submission_id}/${index}`;
    }
    return `/defect_photos/${defect[`photo_${index}`]}`;
}

export function getDefectReportUrl(defect) {
    if (defect.submission_id) {
        return `/api/media/defect-report/${defect.submission_id}`;
    }
    return `/defect_reports/${defect.pdf_ref}`;
}

export function getClosureReportUrl(defect) {
    if (defect.submission_id) {
        return `/api/media/closure-report/${defect.submission_id}`;
    }
    return `/closure_reports/${defect.closure_report}`;
}
